// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#main[data-v-41983bb4]{position:fixed;width:100%;height:100%;margin:0;padding:0;background-color:#ddd}#map-actions-float[data-v-41983bb4]{position:absolute;z-index:-1;right:20px;top:15px}.mgl-map-wrapper[data-v-41983bb4]{left:80px;z-index:-1}#loading-screen[data-v-41983bb4]{width:100%;height:100%;position:absolute;z-index:20;background-color:hsla(0,0%,61%,.5)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
